var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "dashboard px-6 align-content-start",
      attrs: { id: "feedback-dashboard", fluid: "", "fill-height": "" }
    },
    [
      _c(
        "v-row",
        { staticClass: "align-center py-3", attrs: { "no-gutters": "" } },
        [
          _c("img", {
            staticClass: "mr-3",
            attrs: {
              src: require("@/assets/icon-feedback.svg"),
              width: "40px",
              height: "40px"
            }
          }),
          _c("div", { staticClass: "title-header" }, [
            _vm._v("Feedbacks del Portal")
          ])
        ]
      ),
      _c(
        "v-row",
        _vm._l(_vm.feedbackCards, function(type, typeKey) {
          return _c(
            "v-col",
            { key: typeKey },
            [
              _c(
                "v-card",
                {
                  staticClass:
                    "borderbox pa-4 pt-2 elevation-2 white pull-up summary-feedbacks",
                  class: type.cssClass
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "d-flex align-center justify-space-between"
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { size: "64" } },
                        [_vm._v(_vm._s(type.icon))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-uppercase summary-feedbacks--title",
                          staticStyle: {
                            position: "absolute",
                            "margin-left": "27px",
                            "margin-top": "3px",
                            "font-weight": "600"
                          }
                        },
                        [_vm._v(" " + _vm._s(type.category) + " ")]
                      ),
                      _c(
                        "h4",
                        { staticClass: "display-2 mb-1 ml-5 justify-end" },
                        [_vm._v(_vm._s(type.total))]
                      )
                    ],
                    1
                  ),
                  _c("v-progress-linear", {
                    staticClass: "mt-2 align-end",
                    attrs: {
                      height: "5",
                      "background-opacity": "0.2",
                      rounded: "",
                      color: "none",
                      value: (type.total * 100) / _vm.total
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-row",
        { staticClass: "pt-3" },
        [
          _c(
            "v-col",
            { staticClass: "pr-3 py-0", attrs: { cols: "12", md: "6" } },
            [
              _c(
                "v-card",
                { staticClass: "pull-up" },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "pt-1 pb-1" },
                    [
                      _c("h3", { staticClass: "overline" }, [
                        _vm._v("Detalles del Feedback")
                      ]),
                      _c("v-spacer"),
                      !_vm.noFeedbacks
                        ? _c(
                            "span",
                            [
                              _vm._l(_vm.feedbackCards, function(
                                type,
                                typeKey
                              ) {
                                return _c(
                                  "v-tooltip",
                                  {
                                    key: typeKey,
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  {
                                                    staticClass:
                                                      "appreciation-filter",
                                                    class: {
                                                      active:
                                                        _vm.typeSelected ===
                                                        type.categoryId
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.changeFeedbacksType(
                                                          type.categoryId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: { size: "32" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.typeSelected ===
                                                            type.categoryId
                                                            ? type.icon
                                                            : type.icon +
                                                                "-outline"
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "appreciation"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            type.category
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Mostrar feedback calificadas con " +
                                          _vm._s(type.category) +
                                          " pto" +
                                          _vm._s(
                                            type.categoryId > 1 ? "s" : ""
                                          ) +
                                          "."
                                      )
                                    ])
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-icon",
                                              _vm._g(
                                                {
                                                  attrs: { size: "20" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.changeFeedbacksType(
                                                        null
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [_vm._v("mdi-filter-off-outline")]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3719663537
                                  )
                                },
                                [_c("span", [_vm._v("Eliminar Filtro")])]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.comments && _vm.comments.length > 0
                    ? _c(
                        "v-list",
                        { attrs: { "two-line": "" } },
                        [
                          _c(
                            "v-list-item-group",
                            {
                              model: {
                                value: _vm.comments,
                                callback: function($$v) {
                                  _vm.comments = $$v
                                },
                                expression: "comments"
                              }
                            },
                            [
                              _vm._l(_vm.comments, function(feedback, index) {
                                return [
                                  _c(
                                    "v-list-item",
                                    {
                                      key: feedback.id,
                                      class: _vm.getFeedbackType(
                                        feedback.type.id
                                      ).cssClass
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  feedback.rating === null
                                                    ? _vm.getFeedbackType(
                                                        feedback.type.id
                                                      ).icon
                                                    : "mdi-numeric-" +
                                                        feedback.rating +
                                                        "-circle-outline"
                                                ) +
                                                " "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", {
                                            domProps: {
                                              textContent: _vm._s(
                                                feedback.contact
                                              )
                                            }
                                          }),
                                          _c("v-list-item-subtitle", {
                                            staticClass: "text--primary",
                                            domProps: {
                                              textContent: _vm._s(
                                                feedback.nameCustomer
                                              )
                                            }
                                          }),
                                          _c("v-list-item-subtitle", {
                                            domProps: {
                                              textContent: _vm._s(
                                                feedback.client
                                                  ? feedback.client.toLowerCase()
                                                  : ""
                                              )
                                            }
                                          }),
                                          feedback.opinion &&
                                          feedback.opinion !== ""
                                            ? _c("p", {
                                                staticClass: "opinion",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    feedback.opinion
                                                  )
                                                }
                                              })
                                            : _vm._e(),
                                          feedback.rating !== null
                                            ? _c(
                                                "p",
                                                { staticClass: "rating" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Calificación:")
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(feedback.rating) +
                                                      " pto" +
                                                      _vm._s(
                                                        feedback.rating > 1
                                                          ? "s"
                                                          : ""
                                                      ) +
                                                      ". "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-action",
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-list-item-action-text",
                                                          _vm._g(
                                                            {
                                                              domProps: {
                                                                textContent: _vm._s(
                                                                  _vm.setFormatDate(
                                                                    feedback.date
                                                                  )
                                                                )
                                                              }
                                                            },
                                                            on
                                                          )
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.setFormatDate(
                                                      feedback.date,
                                                      false
                                                    )
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  index + 1 < _vm.comments.length
                                    ? _c("v-divider", { key: index })
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "feedback-cards empty-state" },
                        [
                          _c(
                            "v-row",
                            {
                              attrs: {
                                align: "center",
                                justify: "center",
                                "no-gutters": ""
                              }
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-3 mb-0 pa-0 d-flex",
                                  attrs: { cols: "12", "align-self": "center" }
                                },
                                [
                                  _c("img", {
                                    staticClass: "justify-center",
                                    staticStyle: { margin: "0 auto" },
                                    attrs: {
                                      src: require("@/assets/empty-state-feedbacks.png"),
                                      width: "256",
                                      height: "256"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("p", [
                                    _vm._v("No hay elementos para mostrar")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _vm.comments && _vm.comments.length > 0
                    ? _c(
                        "v-card-actions",
                        { staticClass: "pa-0 container--fluid" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "grey lighten-4 ma-0 py-2",
                              staticStyle: { width: "100%" }
                            },
                            [
                              _c("v-pagination", {
                                attrs: {
                                  length: this.allFeedbacks.pages,
                                  "total-visible": 7
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.changeFeedbacksPage()
                                  }
                                },
                                model: {
                                  value: _vm.feedbacksPage,
                                  callback: function($$v) {
                                    _vm.feedbacksPage = $$v
                                  },
                                  expression: "feedbacksPage"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-3 py-0", attrs: { cols: "12", md: "6" } },
            [
              _c(
                "v-skeleton-loader",
                {
                  staticClass: "dashboard-component d-flex pt-0 pb-6",
                  attrs: {
                    transition: "scale-transition",
                    type: "image",
                    height: "130",
                    loading:
                      !_vm.feedbackCards || _vm.feedbackCards.length === 0
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "pull-up" },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "overline pb-1 d-flex justify-start" },
                        [_c("h3", [_vm._v("Calificación promedio")])]
                      ),
                      _c("v-card-text", [
                        _c(
                          "div",
                          { staticClass: "rating-avg text-center" },
                          [
                            _c("v-rating", {
                              attrs: {
                                length: "5",
                                readonly: "",
                                "half-increments": "",
                                "background-color": "rgb(35, 131, 203)",
                                color: "rgb(35, 131, 203)",
                                size: "48",
                                "empty-icon": "mdi-star-outline",
                                "half-icon": "mdi-star-half-full",
                                "full-icon": "mdi-star"
                              },
                              model: {
                                value: _vm.average,
                                callback: function($$v) {
                                  _vm.average = $$v
                                },
                                expression: "average"
                              }
                            }),
                            _c("p", { staticClass: "mt-2 mb-0" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(_vm.average ? _vm.average : 0) +
                                  " pto" +
                                  _vm._s(_vm.average === 1 ? "" : "s") +
                                  ") "
                              )
                            ])
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.feedbackCards || _vm.feedbackCards.length === 0
                ? _c("v-skeleton-loader", {
                    staticClass: "dashboard-component d-flex pt-0 pb-6",
                    attrs: {
                      transition: "scale-transition",
                      type: "image",
                      height: "130",
                      loading: true
                    }
                  })
                : _vm._e(),
              !(!_vm.feedbackCards || _vm.feedbackCards.length === 0)
                ? _c(
                    "v-card",
                    { staticClass: "pull-up" },
                    [
                      _c("v-card-title", { staticClass: "overline pb-1" }, [
                        _c("h3", [_vm._v("Sugerencias recibidas en el mes")])
                      ]),
                      _vm.suggestions && _vm.suggestions.length > 0
                        ? _c(
                            "v-list",
                            { attrs: { "two-line": "" } },
                            [
                              _c(
                                "v-list-item-group",
                                {
                                  model: {
                                    value: _vm.suggestions,
                                    callback: function($$v) {
                                      _vm.suggestions = $$v
                                    },
                                    expression: "suggestions"
                                  }
                                },
                                [
                                  _vm._l(_vm.suggestions, function(
                                    suggestion,
                                    index
                                  ) {
                                    return [
                                      _c(
                                        "v-list-item",
                                        {
                                          key: suggestion.id,
                                          class: _vm.getFeedbackType(
                                            suggestion.type.id
                                          ).cssClass
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getFeedbackType(
                                                        suggestion.type.id
                                                      ).icon
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    suggestion.contact
                                                  )
                                                }
                                              }),
                                              _c("v-list-item-subtitle", {
                                                staticClass: "text--primary",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    suggestion.nameCustomer
                                                  )
                                                }
                                              }),
                                              _c("v-list-item-subtitle", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    suggestion.client
                                                      ? suggestion.client.toLowerCase()
                                                      : ""
                                                  )
                                                }
                                              }),
                                              suggestion.opinion &&
                                              suggestion.opinion !== ""
                                                ? _c("p", {
                                                    staticClass: "opinion",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        suggestion.opinion
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { bottom: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-list-item-action-text",
                                                              _vm._g(
                                                                {
                                                                  domProps: {
                                                                    textContent: _vm._s(
                                                                      _vm.setFormatDate(
                                                                        suggestion.date
                                                                      )
                                                                    )
                                                                  }
                                                                },
                                                                on
                                                              )
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.setFormatDate(
                                                          suggestion.date,
                                                          false
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      index + 1 < _vm.suggestions.length
                                        ? _c("v-divider", { key: index })
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "feedback-cards empty-state" },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    align: "center",
                                    justify: "center",
                                    "no-gutters": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-3 mb-0 pa-0 d-flex",
                                      attrs: {
                                        cols: "12",
                                        "align-self": "center"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "justify-center",
                                        staticStyle: { margin: "0 auto" },
                                        attrs: {
                                          src: require("@/assets/empty-state-feedbacks.png"),
                                          width: "256",
                                          height: "256"
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v("No hay elementos para mostrar")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                      _vm.suggestions && _vm.suggestions.length > 0
                        ? _c(
                            "v-card-actions",
                            { staticClass: "pa-0 container--fluid" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "grey lighten-4 ma-0 py-2",
                                  staticStyle: { width: "100%" }
                                },
                                [
                                  _c("v-pagination", {
                                    attrs: {
                                      length: this.monthSuggestions.pages,
                                      "total-visible": 7
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.changeSuggestionsPage()
                                      }
                                    },
                                    model: {
                                      value: _vm.suggestionsPage,
                                      callback: function($$v) {
                                        _vm.suggestionsPage = $$v
                                      },
                                      expression: "suggestionsPage"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }